import { GetAppSettings } from '../../AppSettings';
import { RecipeResponse } from '../../workfloweditor/workflow-types';

export function getRecipesPerEnvironment(recipeResponse: RecipeResponse) {
  if (recipeResponse == null) {
    return null;
  }
  const { CmsEnvironment } = GetAppSettings();

  return recipeResponse.data?.Workflow_Recipes
    ? recipeResponse.data.Workflow_Recipes.filter((x) => x.environment?.some((env) => env === CmsEnvironment))
    : null;
}
